const StringUtil = {
  escapeRegExp: (text: string): string => {
    if (text) return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string

    return text;
  },

  replaceAll: (text: string, match: string, replacement: string): string => {
    if (text && match && replacement) {
      return text.replace(
        new RegExp(StringUtil.escapeRegExp(match), 'g'),
        () => replacement,
      );
    }

    return text;
  },
};

export default StringUtil;
